import { render, staticRenderFns } from "./product_unique_code_list.vue?vue&type=template&id=c623d6b2&scoped=true"
import script from "./product_unique_code_list.vue?vue&type=script&lang=js"
export * from "./product_unique_code_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c623d6b2",
  null
  
)

export default component.exports